$('.modal-toggle').on('click', function() {
	$this = $(this)
	let videoId = $this.attr('data-id')
	let videoSecondaryId = $this.attr('data-secondary-id')
	let type = $this.attr('data-type')

	let modalParent = $this.siblings('.modal').attr('id')

	let modal = $this
		.siblings('.modal')
		.children('.modal-dialog')
		.children('.modal-content')
		.children('.modal-body')
	let iframeUrl = ''

	if (type == 'youtube') {
		iframeUrl = 'https://www.youtube.com/embed/' + videoId
	}

	if (type == 'vimeo') {
		iframeUrl = 'https://player.vimeo.com/video/' + videoId + '?dnt=1'
	}

	if (type == 'vimeo_livestream') {
		iframeUrl =
			'https://player.vimeo.com/video/event/' +
			videoId +
			'/embed/' +
			videoSecondaryId + '?dnt=1'
	}

	if(type == 'iframe') {
		iframeUrl = $this.attr('data-iframe-src');
	}

	modal.append(
		"<iframe width='1101' height='619.3' src='" + iframeUrl + "'></iframe>"
	)

	document
		.getElementById(modalParent)
		.addEventListener('hide.bs.modal', function(e) {
			modal.children('iframe').remove()
		})
})
